export default class CompanyIdentifier {
  constructor() {
    this.id = '';
    this.issuerCompanyId = '';
    this.identifyingText = '';
    this.identifiedCompanyId = '';
  }

  init(companyIdentifier) {
    this.id = companyIdentifier?.id ?? '';
    this.issuerCompanyId = companyIdentifier?.issuerCompanyId ?? '';
    this.identifyingText = companyIdentifier?.identifyingText ?? '';
    this.identifiedCompanyId = companyIdentifier?.identifiedCompanyId ?? '';
  }
}
